var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanFeature3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87994",
    "data-name": "Group 87994",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.633,
    height: 24.69,
    viewBox: "0 0 24.633 24.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25580",
    "data-name": "Rectangle 25580",
    width: 24.633,
    height: 24.69,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87993",
    "data-name": "Group 87993",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308304",
    "data-name": "Path 308304",
    d: "M3.467,10.442a.343.343,0,1,1-.342.342.342.342,0,0,1,.342-.342",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308305",
    "data-name": "Path 308305",
    d: "M21.164,10.442a.343.343,0,1,1-.342.342.342.342,0,0,1,.342-.342",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308306",
    "data-name": "Path 308306",
    d: "M8.3,9.956v1.4h8.039v-1.4a4.019,4.019,0,1,0-8.039,0",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308307",
    "data-name": "Path 308307",
    d: "M12.842,5.991A4.016,4.016,0,0,0,8.3,9.955h0v1.4H9.35v-1.4a4.006,4.006,0,0,1,3.492-3.965",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308308",
    "data-name": "Path 308308",
    d: "M14.257,11.6a.264.264,0,0,1-.264-.264V9.624a.264.264,0,0,1,.527,0v1.709a.264.264,0,0,1-.263.264",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308309",
    "data-name": "Path 308309",
    d: "M10.376,11.6a.264.264,0,0,1-.264-.264V9.624a.264.264,0,0,1,.527,0v1.709a.264.264,0,0,1-.263.264",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308310",
    "data-name": "Path 308310",
    d: "M12.315.3a2.816,2.816,0,1,1-2.83,2.816A2.823,2.823,0,0,1,12.315.3",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308311",
    "data-name": "Path 308311",
    d: "M10.538,3.114a2.82,2.82,0,0,1,2.3-2.766A2.912,2.912,0,0,0,12.314.3a2.816,2.816,0,1,0,0,5.632h0a2.912,2.912,0,0,0,.527-.05,2.82,2.82,0,0,1-2.3-2.766",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308312",
    "data-name": "Path 308312",
    d: "M21.163,8.394H16.3a4.3,4.3,0,0,0-2.668-2.5A3.1,3.1,0,1,0,11,5.9a4.3,4.3,0,0,0-2.669,2.5H3.467a.264.264,0,0,0-.264.263V9.731a.263.263,0,1,0,.526.032.171.171,0,0,0,0-.032v-.81H8.16a4.246,4.246,0,0,0-.128,1.035v1.4a.264.264,0,0,0,.264.263h3.756v1.862a.264.264,0,1,0,.526.033.182.182,0,0,0,0-.033V11.617h3.756a.263.263,0,0,0,.263-.263v-1.4a4.238,4.238,0,0,0-.128-1.034H20.9v.727a.264.264,0,0,0,.526.033.182.182,0,0,0,0-.033V8.657a.264.264,0,0,0-.263-.263M9.748,3.114A2.558,2.558,0,0,1,11.513.689a3.1,3.1,0,0,0,3.356,2.673,2.567,2.567,0,0,1-5.121-.249ZM16.071,11.1H8.559V9.955a3.756,3.756,0,0,1,7.512,0Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308313",
    "data-name": "Path 308313",
    d: "M.264,20.648v1.136H6.672V20.648a3.2,3.2,0,1,0-6.408,0",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308314",
    "data-name": "Path 308314",
    d: "M3.994,17.458a3.191,3.191,0,0,0-3.73,3.195v1.136H1.317V20.648a3.227,3.227,0,0,1,2.677-3.19",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308315",
    "data-name": "Path 308315",
    d: "M3.467,12.834a2.28,2.28,0,1,1-2.256,2.28,2.268,2.268,0,0,1,2.256-2.28",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308316",
    "data-name": "Path 308316",
    d: "M2.265,15.113A2.275,2.275,0,0,1,3.993,12.9a2.28,2.28,0,1,0,0,4.434,2.275,2.275,0,0,1-1.728-2.217",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308317",
    "data-name": "Path 308317",
    d: "M4.646,17.363a2.546,2.546,0,0,0-1.18-4.793,2.546,2.546,0,0,0-1.179,4.793A3.507,3.507,0,0,0,0,20.658v1.136a.264.264,0,0,0,.264.263H6.67a.263.263,0,0,0,.263-.263V20.658a3.507,3.507,0,0,0-2.287-3.3M1.474,15.117a2.02,2.02,0,0,1,1.308-1.9,2.539,2.539,0,0,0,2.659,2.146,1.99,1.99,0,0,1-3.967-.257Zm4.932,6.411H5.278v-1.14a.264.264,0,0,0-.527,0v1.14H2.182v-1.14a.263.263,0,0,0-.526,0v1.14H.523v-.873a2.962,2.962,0,0,1,2.94-2.974A2.961,2.961,0,0,1,6.4,20.655Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308318",
    "data-name": "Path 308318",
    d: "M17.96,20.648v1.136h6.408V20.648a3.2,3.2,0,1,0-6.408,0",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308319",
    "data-name": "Path 308319",
    d: "M21.691,17.458a3.191,3.191,0,0,0-3.73,3.195v1.136h1.053V20.648a3.227,3.227,0,0,1,2.677-3.19",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308320",
    "data-name": "Path 308320",
    d: "M21.164,12.834a2.28,2.28,0,1,1-2.256,2.28,2.268,2.268,0,0,1,2.256-2.28",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308321",
    "data-name": "Path 308321",
    d: "M19.962,15.113A2.273,2.273,0,0,1,21.689,12.9a2.28,2.28,0,1,0,0,4.434,2.273,2.273,0,0,1-1.727-2.217",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308322",
    "data-name": "Path 308322",
    d: "M22.343,17.363a2.518,2.518,0,1,0-2.358,0,3.5,3.5,0,0,0-2.287,3.3v1.136a.263.263,0,0,0,.263.263h6.408a.263.263,0,0,0,.263-.263V20.658a3.506,3.506,0,0,0-2.289-3.3m-3.172-2.246a2.02,2.02,0,0,1,1.308-1.9,2.539,2.539,0,0,0,2.659,2.151,1.99,1.99,0,0,1-3.967-.256ZM24.1,21.528H22.974v-1.14a.264.264,0,0,0-.527-.033v1.173H19.879v-1.14a.263.263,0,0,0-.526,0v1.14H18.22v-.873a2.94,2.94,0,1,1,5.88-.108q0,.054,0,.108Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308323",
    "data-name": "Path 308323",
    d: "M9.111,23.281v1.135h6.408V23.281a3.2,3.2,0,0,0-6.408-.114Q9.109,23.224,9.111,23.281Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308324",
    "data-name": "Path 308324",
    d: "M12.842,20.091a3.191,3.191,0,0,0-3.73,3.195v1.136h1.053V23.281a3.227,3.227,0,0,1,2.677-3.19",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308325",
    "data-name": "Path 308325",
    d: "M12.315,15.467a2.28,2.28,0,1,1-2.256,2.28,2.268,2.268,0,0,1,2.256-2.28",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308326",
    "data-name": "Path 308326",
    d: "M11.113,17.746a2.273,2.273,0,0,1,1.727-2.217,2.279,2.279,0,1,0-.526,4.5,2.213,2.213,0,0,0,.526-.063,2.273,2.273,0,0,1-1.727-2.217",
    transform: "translate(0 0)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308327",
    "data-name": "Path 308327",
    d: "M13.494,20a2.52,2.52,0,1,0-2.358,0,3.506,3.506,0,0,0-2.288,3.3v1.136a.264.264,0,0,0,.264.263H15.52a.263.263,0,0,0,.263-.263V23.291A3.506,3.506,0,0,0,13.494,20M10.322,17.75a2.02,2.02,0,0,1,1.308-1.9A2.539,2.539,0,0,0,14.289,18a1.99,1.99,0,0,1-3.967-.256Zm4.932,6.411H14.125v-1.14a.264.264,0,1,0-.527-.033v1.173H11.03v-1.14a.263.263,0,0,0-.526,0v1.14H9.371v-.873a2.94,2.94,0,1,1,5.88-.108q0,.054,0,.108Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308328",
    "data-name": "Path 308328",
    d: "M20.484,2.693l.786-1.435.786,1.435,1.436.785-1.436.785L21.27,5.7l-.786-1.435-1.436-.785Z",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308329",
    "data-name": "Path 308329",
    d: "M21.84,2.3,21.27,1.26l-.786,1.434-1.436.785,1.044.57,1.13-.617Z",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308330",
    "data-name": "Path 308330",
    d: "M2.576,2.693l.786-1.435.786,1.435,1.436.785-1.436.785L3.362,5.7,2.576,4.263,1.14,3.478Z",
    transform: "translate(0 0)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308331",
    "data-name": "Path 308331",
    d: "M3.932,2.3,3.362,1.26,2.576,2.692,1.14,3.477l1.044.57,1.13-.617Z",
    transform: "translate(0 0)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308332",
    "data-name": "Path 308332",
    d: "M3.131,5.824,2.382,4.457,1.014,3.709a.265.265,0,0,1-.1-.361.269.269,0,0,1,.1-.1L2.382,2.5l.749-1.367a.266.266,0,0,1,.362-.1.269.269,0,0,1,.1.1L4.342,2.5l1.368.748a.266.266,0,0,1,.1.362.262.262,0,0,1-.1.1l-1.368.748L3.594,5.824a.289.289,0,0,1-.4.059.275.275,0,0,1-.059-.059M1.689,3.479,2.7,4.032a.267.267,0,0,1,.1.1l.554,1.012.554-1.012a.267.267,0,0,1,.1-.1l1.013-.553L4.019,2.925a.267.267,0,0,1-.1-.1L3.365,1.812,2.811,2.825a.267.267,0,0,1-.1.1Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308333",
    "data-name": "Path 308333",
    d: "M21.039,5.825,20.29,4.458,18.922,3.71a.265.265,0,0,1-.1-.361.269.269,0,0,1,.1-.1L20.29,2.5l.749-1.367a.266.266,0,0,1,.362-.1.269.269,0,0,1,.1.1L22.25,2.5l1.368.748a.266.266,0,0,1,.1.362.262.262,0,0,1-.1.1l-1.368.748L21.5,5.825a.288.288,0,0,1-.4.06.263.263,0,0,1-.06-.06M19.6,3.48l1.014.553a.267.267,0,0,1,.1.1l.554,1.012.554-1.012a.267.267,0,0,1,.1-.1l1.013-.553-1-.554a.267.267,0,0,1-.1-.1l-.554-1.013-.554,1.013a.267.267,0,0,1-.1.1Z",
    transform: "translate(0 0)",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanFeature3);
export default __webpack_public_path__ + "static/media/Plan_Feature_3.1bac41382f311f2d03c73d11721b0ccf.svg";
export { ForwardRef as ReactComponent };